
// converts a reactive object to normal object
export const observableToObject = (property) => JSON.parse(JSON.stringify(property));
